module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kj-Ld.0cb8b945.png";